import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const GMKBotanical = () => (
  <ArticleWrapper articleId="gmk_botanical">
    <div className="min-h-screen bg-[#111112] flex flex-col w-full">
      <div className="prose prose-invert mx-auto p-6">
        <h1>GMK Botanical</h1>
        {/* Add your GMK Botanical article content here */}
        <p>This is a placeholder article for the GMK Botanical keycap set. More content coming soon.</p>
      </div>
    </div>
  </ArticleWrapper>
);

export default GMKBotanical;
